import React, { useState, useEffect } from 'react';
import { combineClassNames } from 'core/css';
import { SvgIcon } from 'core/icons';
import { connect } from 'react-redux';
import { setLegalDisclosureOpenedState } from '../../store/actions';
import { useTranslate } from '../../../core/translate';

const LegalDisclosure = ({
  config,
  isLegalDisclosureOpened,
  className,
  showAsStatic,
  isRelative = false,
  dispatch,
}) => {
  const { legalDisclosure } = config;
  const [isOpen, setIsOpen] = useState(
    showAsStatic ? true : isLegalDisclosureOpened
  );
  const [isClosing, setIsClosing] = useState(false);
  const [isOpening, setIsOpening] = useState(false);
  const translate = useTranslate();
  const ariaLabel = translate('legal.disclosure.aria.label.v3');

  useEffect(() => {
    setIsOpen(isLegalDisclosureOpened);
  }, [isLegalDisclosureOpened]);

  const closing = () => {
    dispatch(setLegalDisclosureOpenedState(false));
    setIsClosing(true);
    setIsOpening(false);
    setTimeout(() => {
      setIsOpen(false);
      setIsClosing(false);
    }, 500);
  };
  const onClick = () => {
    if (isOpen) {
      closing();
    } else {
      dispatch(setLegalDisclosureOpenedState(true));
      setIsOpening(true);
      setIsOpen(!isOpen);
    }
  };

  const onClosing = () => {
    closing();
  };

  return (
    <>
      {legalDisclosure ? (
        showAsStatic ? (
          <div
            className={combineClassNames(
              'legal-disclosure__container--static',
              className ? className : ''
            )}>
            <SvgIcon
              name="alert-inverted"
              className="legal-disclosure__icon--static"
            />
            <span className="legal-disclosure__text legal-disclosure__text--static">
              {legalDisclosure}
            </span>
          </div>
        ) : (
          <div
            className={combineClassNames(
              isRelative
                ? 'legal-disclosure__container--relative'
                : 'legal-disclosure__container',
              className ? className : ''
            )}>
            <button
              className="legal-disclosure__button svg-icon--option"
              onClick={onClick}
              aria-label={ariaLabel}>
              <SvgIcon name="alert" className="legal-disclosure__icon" />
            </button>
            {isOpen && (
              <div
                className={combineClassNames(
                  'legal-disclosure__text-container',
                  isOpening ? 'legal-disclosure__text-container--opening' : '',
                  isClosing ? 'legal-disclosure__text-container--closing' : ''
                )}>
                <div className="legal-disclosure__text">{legalDisclosure}</div>
                <button
                  className="legal-disclosure__close-button"
                  onClick={onClosing}
                  aria-label={ariaLabel}>
                  <SvgIcon
                    name="chevron-collapse"
                    className="legal-disclosure__close-icon"
                  />
                </button>
              </div>
            )}
          </div>
        )
      ) : null}
    </>
  );
};

const mapStateToProps = (state) => {
  const { config, isLegalDisclosureOpened } = state;

  return {
    config,
    isLegalDisclosureOpened,
  };
};

export default connect(mapStateToProps)(LegalDisclosure);
